import * as React from "react";
import { usePlaceholderPopupStore } from "@/state/placeholderPopupStore";

export const PlaceholderSidebar: React.FC = () => {
  const { sidebar, setSidebar } = usePlaceholderPopupStore();

  return (
    <div
      className={"border-r-2 border-gray-200"}
      style={{
        width: "20%",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        padding: "1rem",
        color: "#092a45",
        boxSizing: "border-box",
      }}
    >
      <img src="assets/AlphaScript_Logo_Dark_cropped.png" alt="" className="w-36 h-auto object-contain mb-2" />

      <ul style={{ listStyle: "none", padding: 0 }}>
        <li
          style={{
            marginBottom: "0.5rem",
            marginLeft: "0.5rem",
            cursor: "pointer",
            color: sidebar === "share-price-performance" ? "#FF5C35" : "#909090",
          }}
          onClick={() => setSidebar("share-price-performance")}
        >
          Share Price Performance
        </li>
      </ul>
    </div>
  );
};


